import './product-navigation.component.pug'
import './product-navigation.component.scss'

import { throttle } from '../../application/utils/timings'

const element = document.querySelector('.product-navigation')
const setSticky = throttle((isStuck) => {
  element.classList.toggle('is-sticky', isStuck)
  document.body.classList.toggle('is-sticked', isStuck)
}, 50)
const scrollHandler = throttle((event) => {
  const currentOffset = element.getBoundingClientRect().top
  const stickyOffset = parseInt(getComputedStyle(element).top.replace('px', ''))
  const isStuck = currentOffset <= stickyOffset
  setSticky(isStuck)
  element.classList.toggle('is-overlap', event.deltaY < 0 && isStuck)
}, 100)

if (element && window.matchMedia('(min-width: 1321px)').matches) {
  window.addEventListener('wheel', scrollHandler)
  scrollHandler({ deltaY: 1 })
}
